import React from 'react';


export const StageMedical = function({ planData, updateData }) {

  return (

          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium mb-2">Non-Emergency Medical Decision Making</label>
              <select value={planData.medicalDecisions} onChange={function(e) { updateData('medicalDecisions', e.target.value); }}
                className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2" data-testid="medical-decisions">
                <option value="">Select arrangement</option>
                <option value="joint">Joint Medical Decisions</option>
                <option value="plaintiff">Plaintiff Makes Medical Decisions</option>
                <option value="defendant">Defendant Makes Medical Decisions</option>
                <option value="routine-custodial">Routine: Custodial Parent | Major: Joint</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Who is responsible for scheduling yearly checkups?</label>
              <div className="grid grid-cols-3 gap-2">
                {[
                  { id: 'plaintiff', label: 'Plaintiff' },
                  { id: 'defendant', label: 'Defendant' },
                  { id: 'joint', label: 'Joint' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('yearlyCheckupScheduler', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.yearlyCheckupScheduler === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}
                      data-testid={'checkup-scheduler-' + opt.id}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Who may attend yearly checkups?</label>
              <div className="space-y-2">
                {[
                  { id: 'both', name: 'Both Parents May Attend' },
                  { id: 'scheduling-parent', name: 'Only the Scheduling Parent' },
                  { id: 'custodial', name: 'Only the Custodial Parent at Time of Appointment' },
                  { id: 'either', name: 'Either Parent May Attend Independently' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('yearlyCheckupAttendance', opt.id); }}
                      className={'w-full p-3 rounded-lg border text-left text-sm font-medium transition-all ' +
                        (planData.yearlyCheckupAttendance === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}
                      data-testid={'checkup-attend-' + opt.id}>
                      {opt.name}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Who may schedule unforeseen doctor visits during their custody/access time?</label>
              <div className="space-y-2">
                {[
                  { id: 'custodial-parent', name: 'The parent with custody/access at that time', desc: 'Whichever parent currently has the child may schedule and attend' },
                  { id: 'either-notify', name: 'Either parent, with notification to the other', desc: 'Either parent may schedule but must notify the other parent promptly' },
                  { id: 'joint-approval', name: 'Joint approval required except emergencies', desc: 'Both parents must agree unless it is an emergency situation' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('unforeseenVisitScheduler', opt.id); }}
                      className={'w-full p-3 rounded-lg border text-left transition-all ' +
                        (planData.unforeseenVisitScheduler === opt.id ? 'border-[#5A4E9E] bg-[#5A4E9E]/10' : 'border-white/10 hover:border-white/20')}
                      data-testid={'unforeseen-visit-' + opt.id}>
                      <p className="font-medium text-sm">{opt.name}</p>
                      <p className="text-xs text-white/50">{opt.desc}</p>
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Emergency Medical Decisions</label>
              <div className="space-y-2">
                {[
                  { id: 'either', name: 'Either Parent May Decide', desc: 'In an emergency, whichever parent is present may authorize treatment' },
                  { id: 'notify-asap', name: 'Either Parent + Notify ASAP', desc: 'Either parent decides but must notify the other as soon as possible' },
                  { id: 'notify-24h', name: 'Either Parent + Notify Within 24h', desc: 'Either parent decides and notifies within 24 hours' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('emergencyDecision', opt.id); }}
                      className={planData.emergencyDecision === opt.id
                        ? 'w-full p-3 rounded-lg border text-left border-[#EF4444] bg-[#EF4444]/10'
                        : 'w-full p-3 rounded-lg border text-left border-white/10 hover:border-white/20'}>
                      <p className="font-medium text-sm">{opt.name}</p>
                      <p className="text-xs text-white/50">{opt.desc}</p>
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Health Insurance Provider</label>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                {[
                  { id: 'plaintiff', label: 'Plaintiff Provides' },
                  { id: 'defendant', label: 'Defendant Provides' },
                  { id: 'better-plan', label: 'Whoever Has Better Plan' },
                  { id: 'shared', label: 'Shared/Split' },
                ].map(function(opt) {
                  return (
                    <button key={opt.id} onClick={function() { updateData('healthInsurance', opt.id); }}
                      className={'p-3 rounded-lg border text-sm font-medium text-center transition-all ' +
                        (planData.healthInsurance === opt.id ? 'border-[#10B981] bg-[#10B981]/10' : 'border-white/10 hover:border-white/20')}>
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Mental Health / Counseling Decisions</label>
              <select value={planData.mentalHealthDecisions} onChange={function(e) { updateData('mentalHealthDecisions', e.target.value); }}
                className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2">
                <option value="">Select arrangement</option>
                <option value="joint">Joint Decision</option>
                <option value="plaintiff">Plaintiff Decides</option>
                <option value="defendant">Defendant Decides</option>
                <option value="either-initiate">Either Parent May Initiate, Both Informed</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Special Needs / Additional Notes</label>
              <textarea value={planData.specialNeeds} onChange={function(e) { updateData('specialNeeds', e.target.value); }}
                className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-3 h-24 resize-y"
                placeholder="Any special health needs, allergies, ongoing treatment considerations (do not include specific diagnoses)..."
                data-testid="special-needs" />
              <p className="text-xs text-white/30 mt-1">Do not include specific medical diagnoses or protected health information.</p>
            </div>
          </div>
        
  );
};
